/**
 * Copyright © Veeam Software Group GmbH.
 */

/**
 * Copyright © Veeam Software Group GmbH.
 */

/* eslint-disable @typescript-eslint/naming-convention */
import type { BearerToken } from '../interfaces';

export const getEmptyToken = (): BearerToken => ({
    access_token: null,
    refresh_token: null,
    access_expires_in: 0,
    refresh_expires_in: 0,
});

export const isAccessTokenValid = (expiresIn: number | void): boolean => {
    const tokenLiveTime: number | typeof NaN = Number.parseInt(`${expiresIn}`, 10);

    // in runtime, it can be anything
    return !Number.isNaN(tokenLiveTime) && (tokenLiveTime > Date.now());
};
